import { useState } from "react";

import { Button } from "components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { Field, FieldGroup } from "components/ui/field";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { SaveButton } from "components/ui/save-button";

// Controlled dialog: rendered once at the SaveFiltersSelect level so it lives
// outside the combobox popup. The parent owns persistence and closes it on a
// successful save via `open`.
export function SaveFilterDialog({ open, onOpenChange, onSave, isSaving }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleOpenChange = next => {
    if (!next) {
      setName("");
      setDescription("");
    }
    onOpenChange(next);
  };

  const handleSubmit = event => {
    event.preventDefault();
    onSave({ name: name.trim(), description: description.trim() });
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="tw:sm:max-w-sm">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Save filter</DialogTitle>
            <DialogDescription>
              Save the current filters to reuse them later.
            </DialogDescription>
          </DialogHeader>
          <FieldGroup className="tw:py-5">
            <Field>
              <Label htmlFor="save-filter-name">Name</Label>
              <Input
                id="save-filter-name"
                name="name"
                value={name}
                onChange={event => setName(event.target.value)}
                autoFocus
                required
              />
            </Field>
            <Field>
              <Label htmlFor="save-filter-description">Description</Label>
              <Input
                id="save-filter-description"
                name="description"
                value={description}
                onChange={event => setDescription(event.target.value)}
              />
            </Field>
          </FieldGroup>
          <DialogFooter>
            <DialogClose render={<Button variant="outline">Cancel</Button>} />
            <SaveButton
              type="submit"
              saving={isSaving}
              disabled={!name.trim()}
            />
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
